import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import { useLayoutContext } from '../../../Context/Layout.context';
import { updateRole, getRole } from '../../../services/rolesAndPermissions/rolesAndPermissions.service';
import { IRole, IRoleForEditing } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { RoleEditor } from '../RoleEditor/RoleEditor.component';

interface EditRoleProps {
  onClose: () => void;
  onChange: () => void;
  roleProp: IRole;
}

export const EditRole: React.FC<EditRoleProps> = ({ onClose, onChange, roleProp: roleProp }) => {
  const [roleNameFromResponse, setRoleNameFromResponse] = useState<string>(roleProp.roleName);
  const [roleDescriptionFromResponse, setRoleDescriptionFromRespose] = useState<string>(roleProp.roleDescription);

  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();
  useDocumentTitle('Edytuj Rolę');

  useEffect(() => {
    getRole(roleProp.roleId)
      .then((response: AxiosResponse<IRoleForEditing>) => {
        setRoleNameFromResponse(response.data.roleName);
        setRoleDescriptionFromRespose(response.data.description);
      })
      .catch(() => {
        console.error('get_error');
      });
  }, []);

  const handleEditRole = (id: string, newRoleName: string, newDescription: string) => {
    updateRole(id, newRoleName, newDescription).then(
      () => {
        openAlert('success');
        onChange();
        onClose();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <RoleEditor
      title="Edytuj rolę"
      onCancel={handleClose}
      onSave={handleEditRole}
      onChange={onChange}
      roleName={roleNameFromResponse}
      roleDescription={roleDescriptionFromResponse}
      roleId={roleProp.roleId}
    />
  );
};
